import Bg from '@/assets/img/unicef/greeting_bg.png';
import GreetingImg1 from '@/assets/img/unicef/greeting_img1@2x.png';
import GreetingImg2 from '@/assets/img/unicef/greeting_img2@2x.png';
import GreetingSign1 from '@/assets/img/unicef/greeting_sign1@2x.png';
import GreetingSign2 from '@/assets/img/unicef/greeting_sign2@2x.png';
import Button from '@/components/Button';
import Container from '@/components/Container';
import GreetingPopup from '@/components/GreetingPopup';
import Image from '@/components/Image';
import Section from '@/components/Section';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import React, { useState } from 'react';
import styled from 'styled-components';

const Article = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 164px;

  &:last-child {
    margin-bottom: 0;
  }

  .img-wrap {
    width: 40.2%;
    text-align: center;
    padding-top: 120px;
    padding-right: 32px;
    max-width: 480px;

    ${Button} {
      width: 100%;
      max-width: 256px;
      margin-top: 24px;
    }
  }
  .dec-wrap {
    width: 59.8%;
    max-width: 544px;
    ${Tit} {
      .c-blue {
        color: #1cabe2;
      }
    }
    .dec {
      margin-top: 64px;
    }
    .sign {
      margin-top: 55px;
      max-width: 162px;
    }
  }
  &:nth-child(2n + 0) {
    flex-direction: row-reverse;

    .img-wrap {
      padding-top: 72px;
      padding-right: 0;
      padding-left: 32px;

      ${Button} {
        width: 100%;
        max-width: 256px;
        margin-top: 24px;
        padding: 12px 0px;
      }
    }
  }

  ${breakpoint(`tablet`)} {
    flex-wrap: wrap;
    margin-bottom: 170px;
    .img-wrap,
    .dec-wrap {
      width: 100%;
      max-width: 100%;
    }
    .img-wrap {
      padding-top: 0;
      padding-right: 0;

      ${Button} {
        max-width: 100%;
      }
    }

    &:nth-child(2n + 0) {
      .img-wrap {
        padding-top: 0;
        padding-left: 0;

        ${Button} {
          max-width: 100%;
        }
      }
    }
    .dec-wrap {
      width: 100%;
      margin-top: 72px;

      .dec {
        margin-top: 24px;
      }
    }
  }
`;

const SectionTop = styled(Section)`
  background: url(${Bg}) top center no-repeat;
  background-size: 1920px;

  ${breakpoint(`tablet`)} {
  }
`;
const Page = styled.div``;

const GreetingTab: React.FC = () => {
  const [popupOpen, setPopupOpen] = useState(false);
  const [PopupTitle, setPopupTitle] = useState(``); // 업종1
  const [PopupSid, setPopupSid] = useState<PopupData | string | number>(``);

  const open = () => setPopupOpen(true);
  const close = () => setPopupOpen(false);
  return (
    <Page>
      <SectionTop className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">인사말</Tit>
            </h2>
          </SectionHeader>

          <div>
            <Article>
              <div className="img-wrap">
                <Image pcSrc={GreetingImg1} mobileSrc={GreetingImg1} />
                <Button
                  outline
                  color="white-sky"
                  onClick={() => {
                    open();
                    setPopupTitle(`정갑영 회장`);
                    setPopupSid(0);
                  }}
                >
                  정갑영 회장 약력 보기
                </Button>
              </div>
              <div className="dec-wrap">
                <Tit size="s1-5" weight="normal">
                  어린이는 <span className="c-blue">인류의 미래</span>이며{` `}
                  <br />
                  <span className="c-blue">세계의 희망</span>입니다.
                </Tit>
                <p className="dec">
                  전 세계의 어린이를 돕기 위해 유엔기구로 설립된
                  유니세프한국위원회를 이끌게 되어 개인적인 영예와 함께 무거운
                  사명감을 느낍니다.
                  <br />
                  <br />
                  유니세프의 역사와 위상은 널리 알려진 사실입니다만, 특별히
                  한국위원회의 성과는 세계적인 귀감이 되고 있습니다. 한국은
                  43년간 유니세프의 도움을 받아오다 1994년에 역사상 유일무이하게
                  도움을 주는 나라로 전환했을 뿐만 아니라, 현재는 40만이 넘는
                  정기후원자의 기부와 높은 투명성으로 모금의 규모와 운영에서
                  가장 모범적인 유니세프의 국가위원회로 부상했기 때문입니다.
                  <br />
                  <br />
                  이러한 경이적인 성과는 은혜를 잊지 않는 전통적인 한국의 문화와
                  어린이를 위해 베푸는 후원자님들의 숭고한 사랑으로 이룬 기적이
                  아닐 수 없습니다. 얼굴도 모르는 지구 반대편 어린이들이 전쟁과
                  폭력에 울지 않고, 배움으로 차별 받지 않으며, 행복하게 자라길
                  소망하는 후원자님들의 넓고 따뜻한 마음에 새삼 숙연해 집니다.
                  <br />
                  <br />
                  유니세프한국위원회가 최고의 신뢰를 받는 구호기구로 세계적
                  귀감이 되는 전통을 더욱 발전시켜 나가겠습니다.
                  일신우일신(日新又日新)의 마음으로 유니세프의 이념을 달성하기
                  위해 정진하겠습니다. 지구의 지속가능성도 어린이가 중심입니다.
                  <br />
                  <br />
                  어린이가 보다 더 행복한 삶을 누릴 수 있는 세상을 만드는 숭고한
                  여정에 동행해 주시는 후원자 여러분께 다시 한번 깊은 감사의
                  인사를 드립니다.
                </p>
                <Image
                  pcSrc={GreetingSign1}
                  mobileSrc={GreetingSign1}
                  className="sign"
                />
              </div>
            </Article>
            {/* WEB-330: 조미진 사무총장 인사말 히든처리
            <Article>
              <div className="img-wrap">
                <Image pcSrc={GreetingImg2} mobileSrc={GreetingImg2} />
                <Button
                  outline
                  color="white-sky"
                  onClick={() => {
                    open();
                    setPopupTitle(`조미진 사무총장`);
                    setPopupSid(1);
                  }}
                >
                  <span>조미진 사무총장 약력 보기</span>
                </Button>
              </div>
              <div className="dec-wrap">
                <Tit size="s1-5" weight="normal">
                  <span className="c-blue">
                    도움을 받던 나라에서 주는 나라로
                  </span>
                  <br />
                  어린이를 위한 특별한 여정
                </Tit>
                <p className="dec">
                  미래세대를 위한 특별한 여정에 동행하게 돼 기쁘고 설레는 동시에
                  무거운 책임과 사명을 느끼게 됩니다. <br /> <br />
                  도움의 역사를 넘어 나눔의 오늘을 살고 계신 존경하는
                  후원자님들과 기업, 기관, 단체 등 어린이를 위해 함께해 주시는
                  모든 분들께 먼저 감사 인사를 드립니다. 여러분들의 숭고한
                  인류애로 유니세프 한국위원회는 이제 전 세계 유니세프의 존재의
                  이유가 되었습니다. <br /> <br />
                  유니세프 한국위원회는 전쟁의 폐허 속에서 유니세프 구호품만을
                  기다리던 어린이들이 자라 아시아 교육지원 프로그램을 만들고,
                  기아와 질병에 시달리는 수많은 어린 생명들을 살려내며 유니세프
                  5대 모금대국을 이뤄냈습니다. <br /> <br />
                  도움을 받던 나라에서 주는 나라로 거듭난 지 이제 꼭 30년이
                  되었습니다. 세계 주요 공여국이자 유엔아동권리협약이 명시한
                  대표 아동권리옹호 기관으로서 지난 30년간 유니세프 한국위원회는
                  국내 어린이 권리 옹호 활동을 전개해왔습니다. <br /> <br />
                  지역사회, 병원, 기업, 학교 등을 아동친화적 환경으로 만드는
                  ‘유니세프아동친화사회’ 사업을 통해 건강한 디지털 환경 조성,
                  기후위기 극복, 마음건강 지원 등 우리 어린이들의 행복을 위해
                  힘쓰고 있습니다. <br /> <br />
                  모금 대국을 넘어 아동권리옹호 활동의 대표기관이 되기까지는 전
                  세계 어린이의 건강과 안전을 내 아이 일처럼 염려하는 후원자님의
                  따뜻한 마음과 우리 사회 각 분야에서 어린이 권리 보호를 위해
                  다양한 협력과 지원을 이끌어 주시는 모든 분들의 선한 손길이
                  있었습니다. <br /> <br />이 자리를 빌려 다시 한번 존경과
                  감사를 드리며, 유니세프 한국위원회 사무총장으로서 함께해
                  주시는 모든 분들의 아름다운 사랑이 더욱 빛날 수 있도록 항상
                  정진하고 노력하겠습니다. <br />
                  <br />
                  ‘모든 어린이가 행복한 세상’을 향한 모든 분들의 뜻이 온전히
                  실현될 수 있도록 최선을 다 하겠습니다. <br />
                  감사합니다.
                </p>
                <Image
                  pcSrc={GreetingSign2}
                  mobileSrc={GreetingSign2}
                  className="sign"
                />
              </div>
            </Article>
            */}
          </div>
        </Container>
      </SectionTop>
      <GreetingPopup
        isOpen={popupOpen}
        PopTitle={PopupTitle}
        PopSid={PopupSid}
        onRequestClose={close}
      />
    </Page>
  );
};

export default GreetingTab;